/**
 * The kitchen display's one status transition: what tapping an order's action button does
 * next. Pulled out of `KitchenDisplayPage` so the mapping itself — not just the button click —
 * is unit-testable; the page had `'served'` here, which was never a real backend `OrderStatus`
 * (`models/__init__.py` has `delivered`, not `served`), so every "Done" tap 400'd (#35).
 */
export function kdsAction(status, allVoided = false) {
  // Everything on it was taken back: nothing to make, so the one button clears it. It stays
  // on the board until someone does, because a bar may already be pouring the pint.
  if (allVoided) return { nextStatus: 'delivered', actionLabel: 'Clear' };
  if (status === 'pending') return { nextStatus: 'in_progress', actionLabel: 'Start' };
  if (status === 'in_progress') return { nextStatus: 'ready', actionLabel: 'Ready' };
  return { nextStatus: 'delivered', actionLabel: 'Done' };
}
